import React, { useContext, useMemo } from "react";
import MomentsUser from "../../components/MomentsUser";
import { AuthContext } from "../../context/Auth/AuthContext";
import ForbiddenPage from "../../components/ForbiddenPage";

import {
  Box,
  Container,
  Typography,
} from "@mui/material";

import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useTheme as useThemeV4 } from "@material-ui/core/styles";
import { i18n } from "../../translate/i18n";

const ChatMoments = ({ isEmbedded }) => {
  const { user } = useContext(AuthContext);

  // Theme Bridge
  const themeV4 = useThemeV4();
  const theme = useMemo(() => createTheme({
    palette: {
      mode: themeV4.palette.type,
      primary: themeV4.palette.primary,
      secondary: themeV4.palette.secondary,
      error: themeV4.palette.error,
      warning: themeV4.palette.warning,
      info: themeV4.palette.info,
      success: themeV4.palette.success,
      text: themeV4.palette.text,
      background: themeV4.palette.background,
      divider: themeV4.palette.divider,
    },
    shape: {
      borderRadius: themeV4.shape.borderRadius,
    },
    typography: {
      fontFamily: themeV4.typography.fontFamily,
    }
  }), [themeV4]);

  if (user.profile === "user" && user.allowRealTime === "disabled") {
    return <ForbiddenPage />;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{
        backgroundColor: isEmbedded ? "transparent" : (theme.palette.mode === 'light' ? '#f5f5f5' : 'background.default'),
        minHeight: isEmbedded ? 'auto' : '100%',
        p: isEmbedded ? 0 : 3,
        overflowX: 'hidden'
      }}>
        <Container maxWidth="xl" disableGutters>
          {!isEmbedded && (
            <Box sx={{ mb: 4 }}>
              <Typography variant="h4" fontWeight="800" color="primary" gutterBottom>
                Painel de Atendimentos
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Visão em tempo real dos atendimentos por usuário
              </Typography>
            </Box>
          )}

          <Box sx={{ width: '100%' }}>
            <MomentsUser />
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default ChatMoments;
